import { render, staticRenderFns } from "./SearchColorLegend.vue?vue&type=template&id=435eb27b&scoped=true&"
import script from "./SearchColorLegend.vue?vue&type=script&lang=js&"
export * from "./SearchColorLegend.vue?vue&type=script&lang=js&"
import style0 from "./SearchColorLegend.vue?vue&type=style&index=0&id=435eb27b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435eb27b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
